import net from "App/net";

var MachineModelsClient = function () {

};

MachineModelsClient.prototype.getCompanyMachineModels = function (companyId) {
  const url = "/CompanyMachineModels?companyId=" + companyId;
  return net.get(url).then(function (response) {
    return response;
  }).catch(function (error) {
    throw error;
  });
};

MachineModelsClient.prototype.getCompanyDataQualityMachineModels = function (companyId) {
  const url = "/CompanyDataQualityMachineModels?companyId=" + companyId;
  return net.get(url).then(function (response) {
    return response;
  }).catch(function (error) {
    throw error;
  });
};

MachineModelsClient.prototype.getVesselMachineModels = function (vesselId) {
  const url = "/VesselMachineModels?vesselId=" + vesselId;
  return net.get(url).then(function (response) {
    return response;
  }).catch(function (error) {
    throw error;
  });
};

export default new MachineModelsClient();
